export default __webpack_public_path__ + "static/media/img2.9864b0d8.jpg";